import React from "react";
import { CSVLink } from "react-csv";
import { Box, Button } from "@mui/material";

const ExportButton = () => {
  const csvData = [
    [
      "Invoice Version",
      "Invoice Type",
      "Invoice Number",
      "Invoice Ref Number",
      // "Signature",
      // "Issuance Date",
      "Currency Code",
      "Exchange Rate",
      "Bill Frequency",
      "Invoice Date",
      // "Invoice Due Date",
      "Payment Mode",
      "Payment Term",
      "Deposit Amount",
      "Deposit Date",
      "Deposit Number",
      "Deposit Ref Number",
      // "Submission UUID",
      // "Document UUID",
      // "Document Link",
      "Total Exclude Tax",
      "Total Include Tax",
      "Total Payable Amount",
      "Total Net Amount",
      "Total Discount Amount",
      "Total Charge Amount",
      "Total Tax Amount",
      "Rounding Amount",
      "Total Taxable Amount",
      "Total Tax Type Amount",
      "Tax Type",
      // "Remark",
      "E-Invoice Number",
      
      "Supplier Name",
      "Supplier TIN",
      "Supplier Identification Type",
      "Supplier Identification Number",
      "Supplier SST",
      "Supplier Tourism Tax",
      "Supplier Email",
      "Supplier MSIC Number",
      "Supplier Bussiness Nature",
      "Supplier Address 1",
      "Supplier Address 2",
      "Supplier Address 3",
      "Supplier Zipcode",
      "Supplier City",
      "Supplier State",
      "Supplier Country",
      "Supplier Contact Number",
      "Buyer Name",
      "Buyer TIN",
      "Buyer Identification Type",
      "Buyer Identification Number", //Buyer id value (BRN, NRIC, Army)
      "Buyer SST",
      "Buyer Email",
      "Buyer Address 1",
      "Buyer Address 2",
      "Buyer Address 3",
      "Buyer Zipcode",
      "Buyer City",
      "Buyer State",
      "Buyer Country",
      "Buyer Contact Number",

      "Import Number",
      "Incoterms",
      "FTA Info",
      "Exporter Account Id",
      "Export Number",
      "Ship Recipient Name",
      "Ship Recipient Address 1",
      "Ship Recipient Address 2",
      "Ship Recipient Address 3",
      "Ship Recipient Zipcode",
      "Ship Recipient City",
      "Ship Recipient State",
      "Ship Recipient Country",
      "Ship Recipient TIN",
      "Ship Recipient Identification Type",
      "Ship Recipient Identification Value",
      "Line Id",
      "Line Classification Id",
      "Line Description",
      "Line Unit Price",
      "Line Tax Type", //value
      "Line Tax Rate",
      "Line Tax Amount",
      "Line Tax Exemption Description",
      "Line Tax Exemption Amount",
      "Line Total Amount",
      "Line Total Exclude Tax",
      "Line Quantity",
      "Line Unit of Measurement",
      "Line Discount Rate",
      "Line Discount Amount",
      "Line Charge Rate",
      "Line Charge Amount",
      "Line Tariff Code",
      "Line Origin Country",
    ],
  ];

  return (
    <Box m={{ xs: 1, md: 2 }} sx={{ display: "flex", alignItems: "end" }}>
      <CSVLink data={csvData} filename={"QInvo_template.csv"}>
        <Button variant="contained">Download Template</Button>
      </CSVLink>
    </Box>
  );
};

export default ExportButton;
